__turbopack_context__.v({
  "clickable": "ToolHeader-module__sSveUa__clickable",
  "header": "ToolHeader-module__sSveUa__header",
});
